import { render } from "./DeveloperTab.vue?vue&type=template&id=a3d04e4c"
import script from "./DeveloperTab.vue?vue&type=script&lang=js"
export * from "./DeveloperTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__